IREP.GermanyLanding = (function () {
    var selectedDiv;
    var events = [];
    var team = [];

    var loadEvents = function (eventList) {
        events = eventList;
    };

    var loadTeam = function (teamList) {
        team = teamList;
        if (team.length === 0) return;
        loadTeamMember(0);
    };

    var loadTeamMember = function (spot) {
        var teamMember = team[spot];
        var imageSrc = '/50/content/images/avatar.jpg';

        if (teamMember.Image) { // prevents null errors
            imageSrc = 'data:image/png;base64,' + teamMember.Image;
        }

        $('#mtt-bio-pic').attr('src', imageSrc);
        $('#mtt-bio-pic').attr('data-team-member', spot);
        $('#mtt-bio-name').text(teamMember.Name);
        $('#mtt-bio-title').text(teamMember.Title);
        $('#mtt-bio-bio').text(teamMember.Bio);
    };

    var previousTeamMember = function () {
        var currentTeamMember = $('#mtt-bio-pic').attr('data-team-member');
        var newTeamMember = parseInt(currentTeamMember) - 1;
        if (newTeamMember < 0) newTeamMember = team.length - 1;
        loadTeamMember(newTeamMember);
    };

    var nextTeamMember = function () {
        var currentTeamMember = $('#mtt-bio-pic').attr('data-team-member');
        var newTeamMember = parseInt(currentTeamMember) + 1;
        if (newTeamMember > team.length - 1) newTeamMember = 0;
        loadTeamMember(newTeamMember);
    };

    var selectEvent = function (id) {
        var event = $.grep(events, function (e) { return e.Id == id; })[0];
        $('.event-detail-title').text(event.Name);
        $('.event-detail-summary').text(event.Description);
        $('#event-date').text(moment(event.Date).format('DD.MM.YYYY'));
        $('#event-time').text(moment(event.Date).format('hh:mm:ss A'));
        $('#event-duration').text(event.DurationHours + ' hours');
        $('#event-location').text(event.Location);
        $('#event-address > #event-address-1').text(event.Address);
        $('#event-address > #event-address-2').text(event.Address2);
        $('#event-address > #event-address-3').text(event.City + ' ' + event.PostalCode);

        $('.event-details').show();
    };

    var init = function () {
        $('.event').on('click', function () {
            if (selectedDiv == this) {
                $(this).removeClass('event-selected');
                $('.event-details').hide();
                selectedDiv = null;
                return;
            }

            var eventId = $(this).attr('data-event-id')

            selectedDiv = this;
            selectEvent(eventId);
            $('.event').each(function () {
                $(this).removeClass('event-selected');
            });

            $(this).addClass('event-selected');
        });

        $('.previous-member').on('click', previousTeamMember);
        $('.next-member').on('click', nextTeamMember);
    };

    // Stop and start aren't used, but are for dev and can be access from the console
    var stopCarousel = function () {
        $('.carousel').carousel('pause');
    };

    var startCarousel = function () {
        $('.carousel').carousel('cycle');
    };

    return {
        init: init,
        loadEvents: loadEvents,
        loadTeam: loadTeam,
        stopCarousel: stopCarousel,
        startCarousel: startCarousel
    };
})();